export default class HeadingClass {
  constructor(
    public _id: string,
    public name: string,
    public title: string,
    public description: string
  ) {}
}
